<template>
  <div class="content">
    <div class="my-bank-card">
      <div class="add-card">
        <button class="button-style-14" @click="$router.push('/user/bank/create')">
          <span>{{ $t('Bao.new_card_or_account') }}</span>
        </button><span @click="goCSpage()">{{ $t('Bao.delete_card_please_contact_service') }}</span>
      </div>
      <template v-if="creditCard && creditCard.length !== 0">
        <h5>{{ $t('Bao.credit_card') }}</h5>
        <div class="bank-card-list">
          <div v-for="(item, key) in creditCard" :key="key" class="bank-card-item credit-card-frame">
            <div class="credit-card-box">
              <a class="btn-card-edit" @click="showModal(item.id)">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon_trash.png`)">
              </a>
              <p class="credit-card-name">
                {{ item.name }}
              </p>
              <div class="credit-num">
                <div>****</div>
                <div>****</div>
                <div>****</div>
                <div class="show-num">
                  {{ item.credit_card_number }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="getTypeList(1).length !== 0">
        <h5>{{ $t('Bao.bank_card_2') }}</h5>
        <div class="bank-card-list">
          <div v-for="(item, key) in getTypeList(1)" :key="key" class="bank-card-item">
            <p>{{ item.bank_name }}</p>
            <p>{{ $t('Bao.bank_card_number_last_five') }}： {{ showOnlyFiveNum(item.card_number) }}</p>
          </div>
        </div>
      </template>
      <template v-if="getTypeList(3).length !== 0">
        <h5>{{ $t('Bao.cryptocurrency') }}</h5>
        <div class="bank-card-list">
          <div v-for="(item, key) in getTypeList(3)" :key="key" class="bank-card-item">
            <p>{{ item.bank_name }}</p>
            <p>{{ $t('Bao.bank_card_number_last_five') }}： {{ showOnlyFiveNum(item.card_number) }}</p>
          </div>
        </div>
      </template>
      <template v-if="getTypeList(2).length !== 0">
        <h5>{{ $t('Bao.e_wallet') }}</h5>
        <div class="bank-card-list">
          <div v-for="(item, key) in getTypeList(2)" :key="key" class="bank-card-item">
            <p>{{ item.bank_name }}</p>
            <p>{{ $t('Bao.bank_card_number_last_five') }}： {{ showOnlyFiveNum(item.card_number).slice(-5) }}</p>
          </div>
        </div>
      </template>
    </div>
    <div class="popup-frame popup-card-edit" :class="{active: isShowModal}">
      <div class="popup-container popup-dialog popup-dialog-centered popup-dialog-scrollable justify-content-center">
        <div class="popup-package pop-card-edit">
          <button class="btn-close" href="#" @click="isShowModal = false" />
          <div class="popup-content">
            <div class="popup-header" />
            <div class="popup-body">
              <p class="text-center">
                {{ $t('Bao.delete_credit_card_confirm') }}
              </p>
              <div class="credit-edit-frame">
                <button
                  id="close"
                  type="button"
                  class="btn btn-secondary btn-style-outline-secondary "
                  @click="handleDelete"
                >
                  {{ $t('Bao.confirm_btn') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyBanks, getMyCreditCards, deleteCreditCard } from '@/api/bank'
import { showNotice, setErrorMessage } from '@/utils/tool'
import '@/assets/theme_gold/css/bank-card.css'

export default {
  data() {
    return {
      list: [],
      creditCard: [],
      isEmptyBank: false,
      isShowModal: false,
      isEmptyCreditCard: false,
      deleteCardId: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      Promise.all([getMyBanks(), getMyCreditCards()])
        .then(([bankResponse, creditCardResponse]) => {
          if (bankResponse.data.data.length === 0) {
            this.isEmptyBank = true
          }
          this.list = bankResponse.data.data

          if (creditCardResponse.data.data.length === 0) {
            this.isEmptyCreditCard = true
          }
          this.creditCard = creditCardResponse.data.data

          if (this.isEmptyBank && this.isEmptyCreditCard) {
            this.$router.push('/user/bank/create')
          }
        })
        .catch(error => {
          console.error('Error:', error)
        })
    },
    getTypeList(type) {
      return this.list.filter((item) => item.bank_type === type)
    },
    goCSpage() {
      if (this.$store.state.brand.urlInfo.csUrl) {
        window.location.href = this.$store.state.brand.urlInfo.csUrl
      }
    },
    showOnlyFiveNum(num) {
      return num.slice(-5)
    },
    showModal(id) {
      this.isShowModal = true
      this.deleteCardId = id
    },
    handleDelete() {
      this.isShowModal = false
      deleteCreditCard({ id: this.deleteCardId }).then(response => {
        showNotice(response.data.data.message)
        this.deleteCardId = null
        this.getList()
      }).catch(error => {
        setErrorMessage(error.response, this.errors)
      })
    }
  }
}
</script>

<style scoped>
/* @import '@/assets/theme_gold/css/bank-card.css'; */

.popup-body .btn-style-outline-secondary {
  color: #B1A781;
  border: 1px solid #B1A781;
  background-color: transparent;
}

.popup-body .btn-style-outline-secondary:hover,
.popup-body .btn-style-outline-secondary:focus {
	color: #FFF;
	border: 1px solid #B1A781;
	background-color: #B1A781;
}

.popup-frame.popup-card-edit {
  display: none;
}

.popup-frame.popup-card-edit.active {
  display: block;
}

</style>
